import cx from 'classnames';
import { parse } from 'date-fns';
import type { VoidFunctionComponent } from 'react';

import { prettyMDY } from '../../../../shared/utils/dates';
import IconButton from '../../generic/Button/IconButton';
import { icons } from '../../generic/Icon/icons';
import type { IssueExceptionsForDashboard } from '../../../../shared/issuesV2';
import type { SetState } from '../../../types';

import styles from './IssueExceptionsTable.module.less';

const getHumanReadableExpiresAfter = (expiresAfter: string) => {
  const date = parse(expiresAfter, 'yyyy-MM-dd', new Date());
  return prettyMDY(date);
};

type Props = {
  exception: IssueExceptionsForDashboard;
  setModalException: SetState<IssueExceptionsForDashboard | null>;
  hasPermissionToExtend: boolean;
};

const ExceptionTitleContent: VoidFunctionComponent<Props> = ({
  exception,
  setModalException,
  hasPermissionToExtend,
}) => {
  if (!exception.expiresAfter) {
    return <span className={cx(styles.exceptionColumn)}>{exception.exceptionTitle}</span>;
  }

  let tooltipContent: string;
  if (exception.isExpired) {
    tooltipContent = `This exception expired on ${getHumanReadableExpiresAfter(exception.expiresAfter)}. Click to extend.`;
  } else {
    tooltipContent = `This exception will expire on ${getHumanReadableExpiresAfter(exception.expiresAfter)}. Click to extend.`;
  }

  return (
    <span className={cx(styles.exceptionColumn)}>
      {exception.expiresAfter && (
        <IconButton
          isDisabled={!hasPermissionToExtend}
          icon={exception.isExpired ? icons.alarmExclamationO : icons.alarmSnoozeO}
          tooltip={tooltipContent}
          id="exception-expires-after-tooltip"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setModalException(exception);
          }}
        />
      )}
      {exception.exceptionTitle}
    </span>
  );
};

export default ExceptionTitleContent;
